// You can write your custom Javascript here
//PDP state management

(function($){

  var PDPState = 0;

  function PDPChangeState(){
    var index = PDPState;
    index++;
    var target = $('#tab'+index);
    if (!target.hasClass('is-current')){
      var tempTarget = $('.product__tab.is-current');
      tempTarget.fadeOut(400,function(){
        tempTarget.removeClass('is-current');
        target.fadeIn(400, function(){
          target.addClass('is-current');
        });
      });
    }
    $('.product__tabs-nav').find('a').parent().removeClass('is-current');
    $('.product__tabs-nav').find('[href="#tab'+index+'"]').parent().removeClass('is-disabled');
    $('.product__tabs-nav').find('[href="#tab'+index+'"]').parent().addClass('is-current');
  }
  
  $('[smoption]').parent().find('label').each(function(){
    var color = $(this).attr('smcolor');
    var hex = variantLibrary.find(x => x.optionOne === color).hex;
    if (hex.indexOf("#") >= 0){
      $(this).find('span').attr('style', 'background-color:'+hex+';');
    }
    else{
      $(this).find('span').hide();
      $(this).attr('style', 'padding-left:13px;');
    }
    
  });
  
  
  $('.product__colors').each(function(){
    $(this).find('input').first().click();
  });

  $('[href="#tab1"]').on('click', function(e){
    if(!$(this).parent().hasClass('is-disabled')){
      e.preventDefault();
      PDPState = 0;
      PDPChangeState();
    }
  });

  $('[href="#tab2"]').on('click', function(e){
    if(!$(this).parent().hasClass('is-disabled')){
      e.preventDefault();
      PDPState = 1;
      PDPChangeState();
    }
  });

  $('[href="#tab3"]').on('click', function(e){
    if(!$(this).parent().hasClass('is-disabled')){
      e.preventDefault();
      PDPState = 2;
      PDPChangeState();
    }
  });

  $('[href="#tab4"]').on('click', function(e){
    if(!$(this).parent().hasClass('is-disabled')){
      e.preventDefault();
      PDPState = 3;
      PDPChangeState();
    }
  });
  
  $('#tab2').find('select').each(function(){
    $(this).find('option').first().prop('disabled', false);
    $(this).find('option').first().attr('value', 'Please Select Your Height');
  });
  
  var initialSelect = $('#tab2').find('select').first().html();
  
  $('#tab1').find('.product__actions .btn:not(#retrofit)').on('click', function(e){
    e.preventDefault();
    $('#tab2').find('label').first().click();
      PDPState = 1;
      PDPChangeState();
    $("body,html").animate(
      {
        scrollTop: $(".product__tabs-body").offset().top - 140
      },
      800 //speed
    );
    $('#tab2').find('select').each(function(){
      $(this).html(initialSelect)
    });
  });
  
  
  
  $('#tab2').find('.product__actions .btn').on('click', function(e){
    e.preventDefault();

    if ($('#tab2').find('#product-option-1').is(':checked')){

      if ($('#tab2').find('select').val() != 'Please Select Your Height'){
        $('#tab3').find('label').first().click();
        checkoutConfig()
      }
      else{
        $('.stage2Error').slideDown();
        $('#tab2').find('select').attr('style', 'border-color:#BE1E2D;');
        $('.stage2Error').text('Please select your height above.');
      }
      
        }
        else {
          $('#tab3').find('label').first().click();
          console.log('it did run this');
      checkoutConfig();
          
    }
      
    

    
  });
  
  $('#tab2').find('.product__option-actions .btn').on('click', function(e){
    
    e.preventDefault();
    if ($('#tab2').find('select').first().val()){
      $('#tab3').find('label').first().click();
      PDPState = 2;
      PDPChangeState();
    }else{
      $('.stage2Error').slideDown();
      $('#tab2').find('select').attr('style', 'border-color:#BE1E2D;');
    }
  });
 
 $('.noWhiteGlove').on('click', function(){
  if ($(window).width() <= 1024) {
   // $('#tab3').find('label').first().click();
      //PDPState = 2;
      //PDPChangeState();
  }
 });
  
  $('.noIndoorTrainer').on('click', function(){
  if ($(window).width() <= 1024) {
      //PDPState = 3;
      //PDPChangeState();
  }
 });
  
  if ($(window).width() <= 1024) {
    $('.product__option-dropdown').attr('style', 'display:block!important;');
  }
 
  
  $('#tab2').find('select').change(function() {
    $('#tab2').find('select').val($(this).val());
    $('#tab2').find('select').each(function(){
    });
  });
  
  $('#product-option-mobile-2').parent().find('.btn').on('click', function(e){
    e.preventDefault();
    PDPState = 3;
    PDPChangeState();
  });
  
 
  
  $('.addBikeToCart').on('click', function(e){
    e.preventDefault();
      if ($('#tab3').find('#product-option-3').is(':checked') || $('#tab3').find('#product-option-4').is(':checked')){
        var bikeCode = '';
        var bikeName = '';
        var option1 = '';
        var option2 = '';
        var option3 = '';
        if ($('#tab1').find('.option1').length){
        option1 = $('#tab1').find('.option1').find("input:checked").val();
        }
        if ($('#tab1').find('.option2').length){
        option2 = $('#tab1').find('.option2').find("input:checked").val();
        }
        if ($('#tab1').find('.option3').length){
        option3 = $('#tab1').find('.option3').find("input:checked").val();
        }
        for (i=0;i<variantLibrary.length;i++){
          if(option1 == variantLibrary[i].optionOne && option2 == variantLibrary[i].optionTwo && option3 == variantLibrary[i].optionThree){
            bikeCode = variantLibrary[i].id;
            bikeName = variantLibrary[i].title;
          }
        }
        var whiteCode = '32094259970135';
        var height = $('#tab2').find('select').first().val();
        /* Indoor trainer stand - variant id*/
        var indoorCode = '39423827968087';

        var whiteToggle = $('input[name="white-glove"]:checked').val();
        var indoorToggle = $('input[name="product-options"]:checked').val();

        var milliseconds = new Date().getTime();

        bikeCode = bikeCode / 1;
        whiteCode = whiteCode / 1;
        indoorCode = indoorCode / 1;
        console.log(whiteToggle, indoorToggle);


        if (whiteToggle == 'yes' && indoorToggle == 'yes'){
          var objArray = [
          {
            id: whiteCode,
            quantity: 1
          },
          {
            id: bikeCode,
            quantity: 1,
            properties: {
              "Height": height
            }
          }
          ];
        }
        if (whiteToggle == 'yes' && indoorToggle == 'no'){
          var objArray = [
          {
            id: whiteCode,
            quantity: 1
          },
          {
            id: bikeCode,
            quantity: 1,
            properties: {
              "Height": height
            }
          }
          ];
        }
        if (whiteToggle == 'no' && indoorToggle == 'yes'){
          var objArray = [

          {
            id: bikeCode,
            quantity: 1
          }
          ];
        }
        if (whiteToggle == 'no' && indoorToggle == 'no'){
          var objArray = [
          {
            id: bikeCode,
            quantity: 1
          }
          ];
        }

       console.log(objArray);

        CartJS.addItems(objArray, {
            "success": function(data, textStatus, jqXHR) {
                console.log('Added');
                window.location = '/cart';
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log('Error: ' + errorThrown + '!');
            }
        });

      }
      else{
        $('.stage3Error').last().slideDown();
        $('.stage3Error').last().text('Please select an option above.');
        $('[name="product-options"]').parent().find('label').attr('style', 'border-color:#BE1E2D;');
      }
  });


function checkoutConfig() {
      console.log('checkout start');
      if ($('#tab3').find('#product-option-3').is(':checked') || $('#tab3').find('#product-option-4').is(':checked')){
        console.log("checkout run");
        var bikeCode = '';
        var bikeName = '';
        var option1 = '';
        var option2 = '';
        var option3 = '';
        if ($('#tab1').find('.option1').length){
        option1 = $('#tab1').find('.option1').find("input:checked").val();
        }
        if ($('#tab1').find('.option2').length){
        option2 = $('#tab1').find('.option2').find("input:checked").val();
        }
        if ($('#tab1').find('.option3').length){
        option3 = $('#tab1').find('.option3').find("input:checked").val();
        }
        for (i=0;i<variantLibrary.length;i++){
          if(option1 == variantLibrary[i].optionOne && option2 == variantLibrary[i].optionTwo && option3 == variantLibrary[i].optionThree){
            bikeCode = variantLibrary[i].id;
            bikeName = variantLibrary[i].title;
          }
        }
        var whiteCode = '32094259970135';
        var height = $('#tab2').find('select').first().val();
        /* Indoor trainer stand - variant id*/
        var indoorCode = '39423827968087';

        var whiteToggle = $('input[name="white-glove"]:checked').val();
        var indoorToggle = $('input[name="product-options"]:checked').val();

        var milliseconds = new Date().getTime();

        bikeCode = bikeCode / 1;
        whiteCode = whiteCode / 1;
        indoorCode = indoorCode / 1;
        console.log(whiteToggle, indoorToggle);


        if (whiteToggle == 'yes' && indoorToggle == 'yes'){
          var objArray = [
          {
            id: whiteCode,
            quantity: 1
          },

          {
            id: bikeCode,
            quantity: 1,
            properties: {
              "Height": height
            }
          }
          ];
        }
        if (whiteToggle == 'yes' && indoorToggle == 'no'){
          var objArray = [
          {
            id: whiteCode,
            quantity: 1
          },
          {
            id: bikeCode,
            quantity: 1,
            properties: {
              "Height": height
            }
          }
          ];
        }
        if (whiteToggle == 'no' && indoorToggle == 'yes'){
          var objArray = [

          {
            id: bikeCode,
            quantity: 1
          }
          ];
        }
        if (whiteToggle == 'no' && indoorToggle == 'no'){
          var objArray = [
          {
            id: bikeCode,
            quantity: 1
          }
          ];
        }

       console.log(objArray);

        CartJS.addItems(objArray, {
            "success": function(data, textStatus, jqXHR) {
                console.log('Added');
                window.location = '/cart';
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log('Error: ' + errorThrown + '!');
            }
        });

      }
      else{
        $('.stage3Error').last().slideDown();
        $('.stage3Error').last().text('Please select an option above.');
        $('[name="product-options"]').parent().find('label').attr('style', 'border-color:#BE1E2D;');
      }
}




  
  $('#preprod-button').on('click', function(e){
    e.preventDefault();
      if ($('#tab3').find('#product-option-3').is(':checked') || $('#tab3').find('#product-option-4').is(':checked')){
        var bikeCode = '';
        var bikeName = '';
        var option1 = '';
        var option2 = '';
        var option3 = '';
        if ($('#tab1').find('.option1').length){
        option1 = $('#tab1').find('.option1').find("input:checked").val();
        }
        if ($('#tab1').find('.option2').length){
        option2 = $('#tab1').find('.option2').find("input:checked").val();
        }
        if ($('#tab1').find('.option3').length){
        option3 = $('#tab1').find('.option3').find("input:checked").val();
        }
        for (i=0;i<variantLibrary.length;i++){
          if(option1 == variantLibrary[i].optionOne && option2 == variantLibrary[i].optionTwo && option3 == variantLibrary[i].optionThree){
            bikeCode = variantLibrary[i].id;
            bikeName = variantLibrary[i].title;
          }
        }
        var whiteCode = '32094259970135';
        var height = $('#tab2').find('select').first().val();
        /* Indoor trainer stand - variant id*/
        var indoorCode = '39423827968087';

        var whiteToggle = $('input[name="white-glove"]:checked').val();
        var indoorToggle = $('input[name="product-options"]:checked').val();

        var milliseconds = new Date().getTime();

        bikeCode = bikeCode / 1;
        whiteCode = whiteCode / 1;
        indoorCode = indoorCode / 1;
        console.log(whiteToggle, indoorToggle);


        if (whiteToggle == 'yes' && indoorToggle == 'yes'){
          var objArray = [
          {
            id: whiteCode,
            quantity: 1,
            properties: {
              "Height": height
            }
          },
          {
            id: indoorCode,
            quantity: 1
          }
          ];
        }
        if (whiteToggle == 'yes' && indoorToggle == 'no'){
          var objArray = [
          {
            id: whiteCode,
            quantity: 1,
            properties: {
              "Height": height
            }
          }
          ];
        }
        if (whiteToggle == 'no' && indoorToggle == 'yes'){
          var objArray = [
          {
            id: indoorCode,
            quantity: 1
          }
          ];
        }
        if (whiteToggle == 'no' && indoorToggle == 'no'){
          var objArray = [
          ];
        }

       console.log(objArray);

        CartJS.addItems(objArray, {
            "success": function(data, textStatus, jqXHR) {
                console.log('Added');
          //      window.location = '/cart';
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log('Error: ' + errorThrown + '!');
            }
        });

      }
      else{
        $('.stage3Error').last().slideDown();
        $('.stage3Error').last().text('Please select an option above.');
        $('[name="product-options"]').parent().find('label').attr('style', 'border-color:#BE1E2D;');
      }
  });  
  $('.accessoryProd__buyButton').on('click', function(){
    var option1 = '';
    var option2 = '';
    var option3 = '';
    var bikeCode = '';
    if ($('.option1').length){
    option1 = $('.option1').find("input:checked").val();
    }
    if ($('.option2').length){
    option2 = $('.option2').find("input:checked").val();
    }
    if ($('.option3').length){
    option3 = $('.option3').find("input:checked").val();
    }
    for (i=0;i<variantLibrary.length;i++){
      if(option1 == variantLibrary[i].optionOne && option2 == variantLibrary[i].optionTwo && option3 == variantLibrary[i].optionThree){
      	bikeCode = variantLibrary[i].id;
      }
    }
    bikeCode = bikeCode / 1;
    
    var milliseconds = new Date().getTime();
    
    CartJS.addItem(bikeCode, 1, {"Timestamp": milliseconds}, {
        "success": function(data, textStatus, jqXHR) {
            console.log('Added');
          	window.location = '/cart';
        },
        "error": function(jqXHR, textStatus, errorThrown) {
            console.log('Error: ' + errorThrown + '!');
        }
    });
  });
  
  $('.s-line').each(function(){
    var timestamp = $(this).find('span[style="display:none;"]').html();
    $('.table__properties span[style="display:none;"]').each(function(){
      
      if ($(this).html().indexOf(timestamp) >= 0){
        var title = $(this).parent().parent().find('.table__title a').text();
        var target1 = $(this).parent().parent().parent().parent().parent().find('.table__price');
        var target2 = $(this).parent().parent().parent().parent().parent().find('.table__total span');


        if (title.indexOf('Indoor Trainer Stand') >= 0){
          var buffer = target1.text();
          target1.html('<del>'+buffer+'</del>&nbsp;$0.00');
          target2.html('<del>'+buffer+'</del>&nbsp;$0.00');
        }
        if (title.indexOf('White Glove Service') >= 0){
          var buffer = target1.text();
          target1.html('<del>'+buffer+'</del>&nbsp;$0.00');
          target2.html('<del>'+buffer+'</del>&nbsp;$0.00');
        }
      }
    });
  });
  
  $('.i-line').each(function(){
    var timestamp = $(this).find('span[style="display:none;"]').html();
    $('.table__properties span[style="display:none;"]').each(function(){
      
      if ($(this).html().indexOf(timestamp) >= 0){
        var title = $(this).parent().parent().find('.table__title a').text();
        var target1 = $(this).parent().parent().parent().parent().parent().find('.table__price');
        var target2 = $(this).parent().parent().parent().parent().parent().find('.table__total span');


        if (title.indexOf('Indoor Trainer Stand') >= 0){
          var buffer = target1.text();
          target1.html('<del>'+buffer+'</del>&nbsp;$0.00');
          target2.html('<del>'+buffer+'</del>&nbsp;$0.00');
        }
        
      }
    });
  });
  
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  })
  
  
  var newTotal = 0;
  $('.table__total').each(function(){
    var currency = $(this).find('.price').text();
    console.log(currency);
	var number = Number(currency.replace(/[^0-9.-]+/g,""));
    console.log(number);
    if (number){
      newTotal += number
    }
    
  });
  
  newTotal = formatter.format(newTotal)
  
  $('.form__foot .price').text(newTotal);
  
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  function updateDiscounts(){
    
    var totalPrice = $('.realPrice').text().trim().replace('$', '').replace(',', '');
    totalPrice = totalPrice / 1;

    var totalAddDiscount = 0;
    
    $('.table-cart tr').each(function(){
	  var qty = $(this).find('.field-quantity').val();
      $(this).find('.oldPriceMeta').each(function(){
        var priceNum = $(this).attr('price-data').trim().replace('$', '').replace(',', '');
        priceNum = priceNum / 1;
        var totalDiscount = priceNum * qty;
        $(this).attr('totla-original', totalDiscount);
        var displayNum = totalDiscount.toFixed(2);
        displayNum = ' $' + numberWithCommas(displayNum);
        $(this).text(displayNum);
      }); 
      
      var thisDiscount = $(this).find('.table__total').find('del').text().trim().replace('$', '').replace(',', '');
      var thisTotal = $(this).find('.table__total').find('.thisTotal').text().trim().replace('$', '').replace(',', '');
      if (thisDiscount){
        thisDiscount = thisDiscount / 1;
        thisTotal = thisTotal / 1;
		var thisDiff = thisDiscount - thisTotal;
        
        totalAddDiscount += thisDiff
        
        $('.table__subtotal-savings').find('small').text(' $' + numberWithCommas(totalAddDiscount));
      }
    });
 
  }
  updateDiscounts();
  
  setInterval(function(){
    updateDiscounts();
  }, 500);

  
  /**
   * Toggles off model iframe on slide change
   */  
  $('.product__thumbs').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var levARClose = $('#levar_iframe_close');
    if (levARClose.length > 0) {
      levARClose.click();
    }
  });

  $('#levar_mobile_button').click(function() {
    $('#levar-player').click();
  });

  $('#levar-player').click(function() {
    $('html,body').animate({
        scrollTop: $('#levar_photo_box').offset().top
    },'slow');
  });

  $('#retrofit').on('click', function(e){
    e.preventDefault();
	var bikeCode = '';
	var bikeName = '';
	for (i=0;i<variantLibrary.length;i++){
		bikeCode = variantLibrary[i].id;
		bikeName = variantLibrary[i].title;
	}
	var milliseconds = new Date().getTime();
	bikeCode = bikeCode / 1;
	  var objArray = [
	  {
		id: bikeCode,
		quantity: 1
	  }
	  ];
	CartJS.addItems(objArray, {
		"success": function(data, textStatus, jqXHR) {
			console.log('Added');
			window.location = '/cart';
		},
		"error": function(jqXHR, textStatus, errorThrown) {
			console.log('Error: ' + errorThrown + '!');
		}
	});
  });

(function() {
  const targetNode = document.querySelector('.product__price.bread-section');
  if (targetNode){
  const config = { childList: true, subtree: true, characterData: true };

  const callback = function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const element = document.querySelector('[data-testid="bread-placement-bread-checkout-btn-products"][data-placement-i-d="bread-checkout-btn-products"]');

        if (element && element.textContent.includes('As low')) {
          element.textContent = 'Learn More';
          console.log('Text successfully changed.');
          $(".product__price.bread-section").show();
          $('.header__financing').on('click', function(e){
          	const targetclicko = document.querySelector('#bread-checkout-btn-products a');
          	targetclicko.dispatchEvent(new Event('click'));
          });
          $("#bread-checkout-btns").html("View More");
          $(".header__financing").show();
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
  }
 
})();

})(jQuery); 

